import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { PriceDisplay } from './PriceDisplay';
import { motion } from 'framer-motion';
export function PricingOffer() {
  return <section id="comprar" className="py-6 md:py-24 px-4 bg-gray-50 border-y border-gray-200 scroll-mt-20" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <FadeIn className="bg-white border-2 border-celeste rounded-3xl p-6 md:p-12 relative shadow-[0_0_50px_rgba(14,165,233,0.1)]" data-id="element-125">
          {/* Badge */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-celeste text-white font-black uppercase tracking-widest px-6 py-2 rounded-full text-sm md:text-base whitespace-nowrap shadow-md" data-id="element-126">
            Oferta Especial
          </div>

          <div className="text-center mb-4 md:mb-10" data-id="element-127">
            <h2 className="font-display font-black text-4xl md:text-6xl text-gray-900 mb-6 md:mb-10" data-id="element-128">
              Es hoy.
            </h2>

            <div className="flex flex-col items-center justify-center mb-3 md:mb-4" data-id="element-129">
              <p className="text-gray-400 line-through text-xl md:text-2xl font-bold mb-1" data-id="element-130">
                $29.900 ARS
              </p>
              <div className="flex items-center space-x-3" data-id="element-131">
                <span className="text-celeste font-bold text-lg md:text-xl uppercase tracking-widest" data-id="element-132">
                  PRECIO DE LANZAMIENTO:
                </span>
              </div>
              <PriceDisplay basePriceARS={19900} className="font-display font-black text-5xl md:text-7xl text-gray-900 tracking-tighter mt-1" data-id="element-133" />
              <p className="text-red-500 font-medium text-sm md:text-base mt-4 max-w-md mx-auto" data-id="element-134">
                Precio válido por las próximas 24 horas o hasta agotar cupos de
                lanzamiento.
              </p>
            </div>
          </div>

          <motion.a href="https://brandersecomm.myshopify.com/cart/add?id=50694869188855&quantity=1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-celeste text-white font-display font-black text-xl md:text-2xl py-5 md:py-6 px-8 rounded-xl text-center uppercase tracking-wide glow-celeste transition-all shadow-lg" data-id="element-135">
            👉 QUIERO EL EBOOK Y EMPEZAR HOY
          </motion.a>

          <div className="mt-5 md:mt-8 flex flex-col items-center space-y-3 md:space-y-4" data-id="element-136">
            <div className="flex items-center space-x-2 text-gray-500 text-sm" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/oNgDstRQzcM1jATJkyWGMM/MERCADO_PAGO_ICONO_.webp" alt="Mercado Pago" className="h-5 w-5" data-id="element-138" />
              <span data-id="element-139">Pago Seguro con Mercado Pago</span>
            </div>
          </div>

          <div className="mt-6 md:mt-10 bg-gray-50 border border-gray-200 rounded-xl p-5 md:p-8 text-center" data-id="element-140">
            <ShieldCheck size={36} className="text-celeste mx-auto mb-3" data-id="element-141" />
            <h3 className="font-display font-black text-lg md:text-xl text-gray-900 mb-2" data-id="element-142">
              GARANTÍA DE 30 DÍAS
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-143">
              Si el ebook no te sirvió, te devolvemos el{' '}
              <span className="font-bold text-gray-900" data-id="element-144">100% de tu dinero</span>
              . Sin preguntas, sin vueltas. Tenés 30 días para probarlo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}